import axios from '@/utils/request'

/**
 * @description  链接获取接口
 * @param params
 * @returns
 */
 export async function getUrlSetup(params) {
  return axios.get(`/v2/feedback/api/urlSetup`,params)
}


/**
 * @description  链接更新接口
 * @param params
 * url 		调研问卷链接
 * @returns
 */
 export async function setUrlSetup(params) {
  return axios.put(`/v2/feedback/api/urlSetup`,params)
}
